// extracted by mini-css-extract-plugin
export default {"infoSharedRow":"UnlockableLabel_infoSharedRow__Ps-PE"};